<app-vehicle-finance-view *ngIf="env === 'VEHICLE' && !useCredisenseApp"></app-vehicle-finance-view>
<app-vehicle-finance-credisense-view *ngIf="env === 'VEHICLE' && useCredisenseApp"></app-vehicle-finance-credisense-view>